import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { SButton, SButtonProps } from "components/parts";
import { STheme } from "components/styles";
/**
 * キャンセルボタン
 */

/**
 * プロパティ
 */
type Props = Pick<
  SButtonProps,
  | "focusId"
  | "label"
  | "index"
  | "gridColumn"
  | "gridRow"
  | "align"
  | "disabled"
  | "onBlur"
  | "onChange"
  | "onKeyDown"
  | "onClick"
  | "onDoubleClick"
  | "dialog"
  | "dialogAction"
  | "handleSubmit"
>;

/**
 * キャンセルボタン
 *
 * @param label: ボタンのラベル
 * @param index: フォーカス番号(1～)
 * @param gridColumn: CSSグリッドの列位置を指定する
 * @param gridRow: CSSグリッドの行位置を指定する
 * @param disabled: 非活性
 * @returns JSX.Element
 */
export const SCancelButton = (props: Props): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <SButton {...props} />
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: STheme.buttons.cancel,
            color: STheme.buttons.text,
            ":hover": {
              backgroundColor: STheme.buttons.hover.cancel,
              color: STheme.buttons.hover.text,
            },
            padding: "1px 4px",
          },
        },
      },
    },
  },
  { ...STheme }
);
